export default class ModalVideo {
    constructor() {
        this.btnPlay = document.querySelectorAll('.btn-play')
        
        this.modal = document.querySelector('.modal-video')
        this.iframeModal = this.modal.querySelector('iframe')

        this.ready();
    }

    ready() {
        
        this.btnPlay.forEach((item, k) => {
            item.addEventListener('click', (event) => {
                const yid = event.currentTarget.getAttribute('data-yid');
                const legend = event.currentTarget.getAttribute('data-legend');
                this.iframeModal.setAttribute('src', `https://www.youtube.com/embed/${yid}?rel=0`);
                this.modal.querySelector('p').innerHTML = legend;
                this.modal.classList.add('open')
            });
        });
        
        this.modal.querySelector('.modal-video .close-modal').addEventListener('click', () => {
            this.modal.classList.remove('open')
            this.iframeModal.setAttribute('src', 'about:blank');
            this.modal.querySelector('p').innerHTML = '';
        });
        
    }
}
if (document.querySelector('.btn-play')) {
    new ModalVideo();
}